module.exports = __webpack_public_path__ + "img/Table_topR240.458cd853.png";